import { api } from "../api";

/**
 * maintenancesFindAllByActivated
 *
 * Busca as manutenções do veículo por cliente, veículo e status.
 *
 * GET /maintenances/{customerId}/{vehicleId}/{status}
 */
const maintenancesFindAllByActivated = async (
    token: string,
    customerId: number,
    vehicleId: number,
    status: string,
    page: number,
    size: number
) => {
    const response = await api.get(
        `/maintenances/${customerId}/${vehicleId}/${status}?page=${page}&size=${size}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response;
};

export default maintenancesFindAllByActivated;